import { AUTHORIZATION } from "../common/constants";

const authTokenForAPI = () => `Bearer ${localStorage.getItem(AUTHORIZATION)}`;
// const authTokenForAPISK = () => `Basic ${localStorage.getItem(AUTHORIZATION)}`;

export default authTokenForAPI;